/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {Validator} from 'vee-validate';
import {Translations} from 'vuex-i18n';
import LanguageService from '@/services/language';

const namespaceSettings: string = 'settingsModule';

/**
 * Language selector component.
 *
 * Component that provides the options to change language.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-language-selector',
})
export default class LanguageSelector extends Vue {
    @Getter('language', {namespace: namespaceSettings}) public language!: (name: string) => boolean;
    @Action('updateLanguage', {namespace: namespaceSettings}) public updateLanguage: any;

    /**
     * Supported languages.
     *
     * @type {{[s: string]: string}}
     */
    public readonly languages: {[s: string]: string} = {
        en: 'English', // Eniglish
        de: 'Deutsch', // German
        es: 'Español', // Spanish
        fr: 'Français', // French
        pt_pt: 'Português', // Portuguese
        ja: '日本語', // Japanese
        zh_tw: '繁體中文', // Chinese (traditional)
        zh_cn: '简体中文', // Chinese (generic/simplified)
        ko: '한국어', // Korean
    };

    /**
     * Language set getter.
     *
     * @returns {{name: string; key: string}[]}
     */
    get languageSet(): {name: string, key: string}[] {
        return Object.keys(this.languages).map((key: string) => {
            return {name: this.languages[key], key};
        });
    }

    /**
     * Select a new language.
     *
     * @param {string} language
     */
    public async selectLanguage(language: string): Promise<void> {
        LanguageService.updateLanguage(language);

        // hide modal
        this.$modal.hide('language-selector');
    }
}

